import React from 'react';
import { __ } from '@wordpress/i18n';
import RelatedJobBox from './RelatedJobBox';
import ShowMoreButton from "./JobSingleShowMoreButton";

//api calls
import jobstreamurl from '../api/jobs.js';
import axios from 'axios';

class JobRelatedPositions extends React.Component {

  state = {
    relatedjobs: [],
    jobstreamurl: '',
  }

  componentDidMount() {
    this.fetchJobstreamUrl();
  }

  fetchJobstreamUrl = async () => {
    const jobstream_url = await jobstreamurl.get('');

    this.setState({
      jobstreamurl : jobstream_url.data,
    },
      this.fetchAllData,
    );
  }

  getQuery() {
    let experience_level = this.props.job_data.experience_level;
    let department = this.props.job_data.department;
    let queryArgs = {
      'experience_level': experience_level,
      'department': department,
    }

    let key
    let query = []

    for (key in queryArgs) {
      // Exclude undefined parameters
      if ( (queryArgs.hasOwnProperty(key) && 'undefined' === typeof(queryArgs[key])) || ('' === queryArgs[key]) ) {
        delete queryArgs[key]
      } else {
        // Add existing params to array
        query.push(key + ':' + queryArgs[key])
      }
    }
    // Build query string
    return query.join( ' AND ' )
  }

  fetchJobs = async () => {
    let query = this.getQuery()
    const response = await axios.get(this.state.jobstreamurl, {
      params: {
        size: 3,
        query: query,
      }
    }).then(response =>
      this.setState({
        relatedjobs : response.data,
      })
    );
  }

  fetchAllData = async () => {
    this.fetchJobs()
  }

  render() {

    return (
      <section className="section section--white-boxes section--job-related">
        <div className="container">
          <div className="content-title">
            <h2>{ __( 'Related positions', 'macs-react-jobs' ) }</h2>
          </div>
          <div className="row">
            {
              this.state.relatedjobs.data ? ( this.state.relatedjobs.data.map( singleJob => <RelatedJobBox data={singleJob} /> ) ) : <h3>{ __( 'Loading...', 'macs-react-jobs' ) }</h3>
            }
          </div>
          <ShowMoreButton />
        </div>
      </section>
    )
  }
}

export default JobRelatedPositions;
